module.exports = __webpack_public_path__ + "static/img/dongfu-exterior-v1.35fb231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spirit-farm/dongfu-exterior-v1.jpg
// module id = bLL8
// module chunks = 4